// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let BrokerResponseMessage = function (fieldSet)
{
    this.Code = Message.CODE_PFIX_BROKER_RESPONSE_MESSAGE
    PFixMessage.call(this, fieldSet)
}
BrokerResponseMessage.prototype = Object.create(PFixMessage.prototype)

BrokerResponseMessage.prototype.setId = function (id)
{
    this.setFieldValue(FieldsFactory.FIELD_ID, id);
}
BrokerResponseMessage.prototype.setValue = function (value)
{
    this.setFieldValue(FieldsFactory.FIELD_VALUE, value);
}
BrokerResponseMessage.prototype.setUserID = function (userID)
{
    this.setFieldValue(FieldsFactory.FIELD_USER_ID, userID);
}
BrokerResponseMessage.prototype.setUsername = function (userName)
{
    this.setFieldValue(FieldsFactory.FIELD_LOGIN, userName);
}
BrokerResponseMessage.prototype.setResponseType = function (responseType)
{
    this.setFieldValue(FieldsFactory.FIELD_BROKER_MESSAGE_RESPONSE_TYPE, responseType);
}